import React from "react";
import styles from "./BtnToAction.module.css";
const BtnToAction = ({ children, action, icon }) => {
  return (
    <div className={styles.itemeach} onClick={() => action()}>
      <div className={styles.iconpart}>
        <i className={icon}></i>
      </div>

      {children}
    </div>
  );
};

export default BtnToAction;
